/**
 * WhatsApp sharing utility for iStudyPro
 * Pre-formatted messages for viral sharing
 */

const WHATSAPP_BASE = 'https://wa.me/?text=';

export const shareOnWhatsApp = (text) => {
  const encoded = encodeURIComponent(text);
  window.open(`${WHATSAPP_BASE}${encoded}`, '_blank');
};

export const shareChallenge = (challengeId, creatorName, score, subject) => {
  const url = `${window.location.origin}/challenge/${challengeId}`;
  const text = `${creatorName} scored ${score}% on ${subject || 'a quiz'} and is challenging YOU! Can you beat them?\n\nTake the challenge: ${url}\n\niStudyPro - The Facebook of Easy Learning`;
  shareOnWhatsApp(text);
};

export const shareStudyKit = (shareId, title, flashcardCount, quizCount) => {
  // Use OG-wrapped URL so WhatsApp/iMessage/Twitter render a rich preview card.
  // The wrapper sits on the backend; it serves OG meta to crawlers and
  // meta-refreshes real users into the SPA route.
  const ogBase = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  const url = `${ogBase}/api/og/share/${shareId}`;
  const text = `Check out "${title}" - ${flashcardCount} flashcards & ${quizCount} quizzes ready to study!\n\n${url}\n\niStudyPro - Study smarter, not harder`;
  shareOnWhatsApp(text);
};

export const shareReferral = (code, userName) => {
  const url = `${window.location.origin}/login?ref=${code}`;
  const text = `${userName || 'I'} invite${userName ? 's' : ''} you to join iStudyPro! Get 7 days of Pro features FREE.\n\nSign up with my link: ${url}\n\nAI-powered study assistant that turns your lectures into flashcards, quizzes & summaries.`;
  shareOnWhatsApp(text);
};

export const shareExamScore = (score, subject, grade) => {
  const url = `${window.location.origin}/login`;
  const text = `I just scored ${score}% (Grade ${grade}) on my ${subject || ''} exam on iStudyPro!\n\nJoin me and ace your exams: ${url}`;
  shareOnWhatsApp(text);
};

export const shareMarketplaceListing = (listingId, title, price) => {
  const url = `${window.location.origin}/marketplace?listing=${listingId}`;
  const text = `"${title}" study notes available ${price === 'Free' ? 'for FREE' : `for ${price}`} on iStudyPro Marketplace!\n\n${url}`;
  shareOnWhatsApp(text);
};

export const shareTutorProfile = (tutorName, subjects) => {
  const url = `${window.location.origin}/tutors`;
  const text = `${tutorName} is offering tutoring in ${subjects.join(', ')} on iStudyPro!\n\nBook a session: ${url}`;
  shareOnWhatsApp(text);
};
